<template>
  <main>
    <v-container>
      <v-row>
        <v-col class="d-flex align-center py-2 px-4">
          <v-breadcrumbs :items="breadcrumbs" class="px-0 py-0" />
        </v-col>
        <v-col class="d-flex justify-end align-center py-2 px-4">
          <router-link :to="redirectToEditView($route.params.id)" class="mr-4">
            <v-btn color="primary" link depressed>Edit</v-btn>
          </router-link>
          <v-btn
            :loading="checkResourceIsDeleting($route.params.id)"
            color="error"
            link
            depressed
            @click="showDeleteModal()"
            >Delete</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col>
          <v-card outlined>
            <!-- Tabs -->
            <v-tabs v-model="tab" background-color="primary" dark show-arrows>
              <v-tab>Details</v-tab>
            </v-tabs>

            <!-- Tab Items -->
            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false">
                <v-list dense>
                  <template v-for="(item, index) in resourceItems">
                    <div :key="index">
                      <v-list-item>
                        <v-list-item-content class="font-weight-medium">{{ item.title }}</v-list-item-content>
                        <v-list-item-content v-if="item.type === 'text'" class="align-end">
                          {{ item.value }}
                        </v-list-item-content>
                        <v-list-item-content v-if="item.type === 'tick'" class="align-end">
                          <tick-or-cross :value="!!item.value" class="justify-start" />
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="index !== resourceItems.length - 1" />
                    </div>
                  </template>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <delete-modal
      v-if="deleteModalVisible"
      v-model="deleteModalVisible"
      :is-disabled="isDeleting"
      :is-loading="isDeleting"
      :item="deletingResource"
      :category="resourceType"
      @modal-confirm="onResourceDeleteConfirmed"
      @modal-cancel="onResourceDeleteCancelled"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PermissionsHandler from '@/mixins/permissions-handler'
import ViewResource from '@/mixins/view-resource'
import DeleteResource from '@/mixins/delete-resource'

export default {
  name: 'EventsView',
  mixins: [PermissionsHandler, ViewResource, DeleteResource],
  data() {
    return {
      resourceKey: 'name.en',
      resourceType: 'Event',
      resourcePrefix: 'content.events',
      resourceKeys: [
        { title: 'ID', key: 'id' },
        { title: 'Name', key: 'name.en' },
        { title: 'Description', key: 'description.en' },
        { title: 'Type', key: 'type' },
        { title: 'Date From', key: 'date_from' },
        { title: 'Date To', key: 'date_to' },
        { title: 'Address Line 1', key: 'address_line_1' },
        { title: 'Address Line 2', key: 'address_line_2' },
        { title: 'City', key: 'city' },
        { title: 'State', key: 'state' },
        { title: 'Postcode', key: 'postal_code' },
        { title: 'Country', key: 'country' },
        { title: 'Latitude', key: 'latitude' },
        { title: 'Longitude', key: 'longitude' },
        { title: 'Website', key: 'website' },
        { title: 'Featured Image', key: 'featured_image' },
        { title: 'Featured', key: 'featured', type: 'tick' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      resource: 'events/getEvent',
    }),
  },
  methods: {
    ...mapActions({
      findResource: 'events/find',
      deleteResource: 'events/delete',
    }),
  },
}
</script>
